// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Hmac","right":"styles_right__2TXlP"};